const list3 = [{
    id: 1,
    className: 'flex-1',
    name: '心肝脑-到会礼1',
    label: 388,
    tag: ''
}, {
    id: 2,
    className: 'flex-1',
    name: '心肝脑-到会礼2',
    label: 600,
    tag: ''
}, {
    id: 3,
    className: 'flex-1',
    name: '肠肝脑-到会礼1',
    label: 388,
    tag: ''
}, {
    id: 4,
    className: 'flex-1',
    name: '肠肝脑-到会礼2',
    label: 680,
    tag: ''
}];

export const list = [list3];
export const expendList = [...list3];

export const item = JSON.parse(JSON.stringify({
    personName: "",
    personIdCard: "",
    personPhone: "",
    checkStartTime: "",
    productList: [],
    sum: 0,
}));
